module.exports = __webpack_public_path__ + "static/media/jabra-elite-65t.4fd48262.png";